import React,{Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { l } from '../functions';


class SaveDialog extends Component {
    state = {
        open : false
    }

    _closeDialog = (cb = () => {}) => {
        cb();
    }

    componentWillReceiveProps({open}){
        if( this.props.open !== open )
            this.setState({open:open});
    }

    render() {
        return (
            <Dialog
                open={this.state.open}
                onClose={() => { this._closeDialog(this.props.deny) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{l('Your modifications will be lost')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {l('You are going to lose your modifications by changing the page without saving. Are you sure ?')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button onClick={() =>{ this._closeDialog(this.props.deny) }}><span>{l('Do not save')}</span></button>
                    <button onClick={() =>{ this._closeDialog(this.props.confirm) }}><span>{l('Save')}</span></button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default SaveDialog